export function isNeedToShowFlatItemIcons({ isArchived, isHovered }) {
  return isArchived || isHovered
}
